import axios from "axios";
import { getBarGraph } from "@redux/actions/homePage-actions";
import { BASE_URL } from "../../../variables";
import _ from "lodash";
import {
  getCheckInDealerDetails,
  getCheckInWSSDetails,
} from "@redux/actions/checkinDetails-actions";

const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) resolve(null);

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove metadata (e.g., "data:application/pdf;base64,") and keep only base64 content
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const checkedInapi =
  (
    RecordtypeName,
    territoryCheckIn,
    dealer,
    dealerCode,
    wss,
    customerCode,
    currentLatitude,
    currentLongitude,
    flag,
    masterLatitude,
    masterLongitude,
    distance,
    accuracy,
    currentAccuracyFactor,
    Checked,
    retailCounter,
    nonPerforming,
    nonPerformingCompany,
    Dealer_Check_in,
    fileBody,
    fileName
  ) =>
  async (dispatch) => {
    let payload = {
      RecordtypeName: RecordtypeName,
      territory: territoryCheckIn,
      dealer: dealer,
      dealercode: dealerCode,
      customer: wss,
      customercode: customerCode,
      Transaction_lat: currentLatitude,
      Transaction_long: currentLongitude,
      IsValidCheckIn: flag,
      Master_lat: masterLatitude,
      Master_long: masterLongitude,
      Trasanction_distance: distance,
      Master_Accuracy: accuracy,
      Current_Accuracy: currentAccuracyFactor,
      Is_Correct_CheckIn: Checked,
    };

    if (RecordtypeName === "Visit Plan WSS") {
      payload = {
        ...payload,
        Retail_counter_present: retailCounter,
        non_performing_status: nonPerforming,
        Company_Name: nonPerformingCompany,
      };
    } else {
      const encodedFileBody = fileBody
        ? await convertFileToBase64(fileBody)
        : null;

      if (encodedFileBody) {
        payload = {
          ...payload,
          Dealer_Check_in: Dealer_Check_in,
          fileBody: encodedFileBody,
          fileName: fileName,
        };
      } else {
        payload = {
          ...payload,
          Dealer_Check_in: Dealer_Check_in,
        };
      }
    }

    const options = {
      url: `${BASE_URL}/services/apexrest/CheckIn_VisitPlan/`,
      method: "post",
      data: payload,
    };

    try {
      const response = await axios(options);
      if (response.status === 200) {
        dispatch(getBarGraph());
        if (RecordtypeName === "Visit Plan") {
          dispatch(getCheckInDealerDetails());
        } else {
          dispatch(getCheckInWSSDetails());
        }
        return {
          success: true,
          data: response?.data,
        };
      } else {
        throw Error("Something Went Wrong..!!");
      }
    } catch (err) {
      return {
        success: false,
        msg: `You are already checked-in for ${
          !_.isEmpty(dealer) ? dealer : "this"
        } dealer!`,
      };
    }
  };
